import {
    AbstractControl,
    ValidatorFn,
    FormControl,
    FormGroup,
    ValidationErrors
  } from '@angular/forms';
  
  export class CustomValidators {

  
    static onlyChar(): ValidatorFn {
      return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (control.value == '') return null;
  
        let re = new RegExp('^[a-zA-Z ]*$');
        if (re.test(control.value)) {
          return null;
        } else {
          return { onlyChar: true };
        }
      };
    }
    static mustMatch(control: AbstractControl): ValidationErrors | null  {

      if (control) {
        const password = control.get('password');
        const confirmPassword = control.get('confirmPassword');

       
        if (confirmPassword?.errors && !confirmPassword.errors["mustMatch"]) {
          return null;
        }
        if (password?.value !== confirmPassword?.value) {
          confirmPassword?.setErrors({ mustMatch: true });
        } else {
          confirmPassword?.setErrors(null);
        }
      }

      return null;
    }

    static changeMustMatch(control: AbstractControl): ValidationErrors | null  {

      if (control) {
        const newPassword = control.get('newPassword');
        const confirmPassword = control.get('confirmPassword');

        if (confirmPassword?.errors && !confirmPassword.errors["mustMatch"]) {
          return null;
        }
        if (newPassword?.value !== confirmPassword?.value) {
          confirmPassword?.setErrors({ mustMatch: true });
        } else {
          confirmPassword?.setErrors(null);
        }
      }

      return null;
    }
  }